import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { createTransform } from 'redux-persist';
//
import appReducer from './slice/appSlice';
import authReducer from './slice/authSlice';
import adminReducer from './slice/adminSlice';
import transfereeUserReducer from './slice/transfereeUserSlice';
import bankUserReducer from './slice/bankUserSlice';
import notapUserReducer from './slice/notapUserSlice';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { appConfig } from '../../config';
import { digitalLetterManagementTransform } from '../../helpers/helpers';



const rootPersistConfig = {
    key: 'root',
    storage:storage,
    whitelist: ['authData']
}

const appDataPersistConfig = {
    key : 'appData',
    storage : storage,
    whitelist: ['certificateManagement', 'digitalLetterManagement', 'currencies'],
    stateReconciler : autoMergeLevel2
}

const authPersistConfig = {
    key : 'authData',
    storage : storage,
    whitelist: ['token', 'user_role', 'userData', 'email'],
    stateReconciler : autoMergeLevel2
}

const bankUserPersistConfig = {
    key: 'bankUser',
    storage: storage,
    whitelist: ['certificateManagement', 'digitalLetterManagement', 'searchResult'],
    // transforms: [digitalLetterManagementTransform],
    stateReconciler : autoMergeLevel2
}

const notapUserPersistConfig = {
    key: 'notapUser',
    storage: storage,
    // whitelist: ['certificateManagement', 'digitalLetterManagement', 'searchResult'],
    // transforms: [digitalLetterManagementTransform],
    stateReconciler : autoMergeLevel2
}

const transfereeUserPersistConfig = {
    key: 'transfereeUser',
    storage: storage,
    whitelist: ['certificateManagement', 'digitalLetterManagement', 'searchResult'],
    // transforms: [digitalLetterManagementTransform],
    stateReconciler : autoMergeLevel2
}

const rootReducer = combineReducers({
    admin: adminReducer,
    app: persistReducer(appDataPersistConfig, appReducer),
    authData:persistReducer(authPersistConfig,authReducer),
    bankUser:persistReducer(bankUserPersistConfig,bankUserReducer),
    notapUser:persistReducer(notapUserPersistConfig,notapUserReducer),
    transfereeUser:persistReducer(transfereeUserPersistConfig,transfereeUserReducer) 
})

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    devTools: appConfig.appEnv !== 'production',
    middleware : [thunk]
})

export const persist = persistStore(store)